/******************************************************************************
 *                                                                            *
 *  Copyright (c) 2018, 2025 by AsterionDB Inc.                               *
 *                                                                            *
 *  All rights reserved.  No part of this work may be reproduced or otherwise *
 *  incorporated into other works without the express written consent of      *
 *  AsterionDB Inc.                                                           *
 *                                                                            *
 *****************************************************************************/

import React from 'react'
import { FormGroup, Form, Col, Row,  Label, Input, Button, ButtonToolbar, ButtonGroup } from 'reactstrap'

import "react-table-legacy/react-table.css";
import ReactTable from 'react-table-legacy'

import AddKeywordToGroupModal from './AddKeywordToGroupModal.js'
import SuggestedKValuesModal from './SuggestedKValuesModal.js'
import ConfirmationModal from '../widgets/ConfirmationModal'

import {AppContext} from '../AppContext';

class KeywordsInAGroup extends React.Component 
{
  selectedRow = undefined;
  
  closeAddKeywordModal(refresh)
  {
    if (refresh) this.getKeywords();

    this.setState({addKeywordModalIsOpen: false});
  }

  async closeConfirmationModal(confirmed)
  {
    this.setState({confirmationModalIsOpen: false});
    if (!confirmed) return;

    let bodyData = {};
    bodyData.keywordId = this.selectedRow.keywordId;

    let result = await this.context.dbTwig.callRestAPI('dgBunker', 'removeKeywordFromGroup', bodyData);
    if ('success' !== result.status) return this.context.dbTwig.apiErrorHandler(result, 'Error removing keyword from group');

    this.context.postNotification('info', 'Keyword removed.');
    this.getKeywords();
  }

  closeSuggestedModal()
  {
    this.setState({suggestedModalIsOpen: false});
  }

  componentDidUpdate(prevProps)
  {
    if (undefined === this.props.keywordGroup && undefined !== prevProps.keywordGroup)
    {
      this.setState({keywordGroupData: []});
      return;
    } 

    if (prevProps.keywordGroup !== this.props.keywordGroup) this.getKeywords();
  }

  confirmDeleteKeyword(rowInfo)
  {
    this.selectedRow = rowInfo;
    this.setState({confirmationModalIsOpen: true});
  }

  constructor(props) 
  {
    super();

    this.state =
    {
      addKeywordModalIsOpen: false,
      keywordInfo: null,
      suggestedKeywordValues: [],
      confirmationModalIsOpen: false,
      keywordGroupData: []
    }

    this.newKeyword = this.newKeyword.bind(this);
    this.closeAddKeywordModal = this.closeAddKeywordModal.bind(this);
    this.closeSuggestedModal = this.closeSuggestedModal.bind(this);
    this.closeConfirmationModal = this.closeConfirmationModal.bind(this);
    this.fetchSuggestedKeywordValues = this.fetchSuggestedKeywordValues.bind(this);
    this.confirmDeleteKeyword = this.confirmDeleteKeyword.bind(this);
    this.getKeywords = this.getKeywords.bind(this);
  }

  async getKeywords()
  {
    let bodyData = {};
    bodyData.keywordGroupId = this.props.keywordGroup.keywordGroupId;
    let result = await this.context.dbTwig.callRestAPI('dgBunker', 'getKeywords', bodyData); 
    if ('success' !== result.status) return this.context.dbTwig.apiErrorHandler(result, 'Error getting keyword group data');
    if (null !== result.jsonData.keywordsInAGroup) this.setState({keywordGroupData: result.jsonData.keywordsInAGroup});
  }

  async fetchSuggestedKeywordValues(keywordId)
  {
    let bodyData = {keywordId: keywordId};
    let result = await this.context.dbTwig.callRestAPI('dgBunker', 'getStaticSuggestionList', bodyData);
    if ('success' !== result.status) return this.context.dbTwig.apiErrorHandler(result, 'Error getting suggested keyword values');
    this.setState({suggestedKeywordValues: result.jsonData.suggestedKeywordValues});
  }
  
  newKeyword()
  {
    if (!this.props.keywordGroup)
    {
      this.context.postNotification('info', 'Select a keyword group first.');
      return;
    }

    this.setState({ addKeywordModalIsOpen: true });
  }

  modalClosed(refresh)
  {
    if (refresh) this.getKeywords();
  }

  render() 
  {
    const columns =
    [
      {accessor: 'keywordId', show: false},
      {Header: 'Keyword', accessor: 'keyword'},
      {Header: 'Value Type', accessor: 'keywordValueType'},
      {Header: 'User Input Handling', accessor: 'userInputHandling',
        Cell: (cellInfo) =>
        {
          if ('true or false' !== cellInfo.row.keywordValueType && 'yes or no' !== cellInfo.row.keywordValueType)
            return (
              <Form  id="userInputHandlingRadios">
                <Col>
                <Row><Col><FormGroup check className="form-checkinline">
                  <Label>
                    <Input checked={cellInfo.row.userInputHandling === 'dynamic list' ? true : false} type="radio" name="userInputHandlingRadio" 
                      value="dynamic list" onChange={this.userInputHandlingRadioChanged.bind(this, cellInfo)}
                    />
                    Dynamic Suggestion List
                  </Label>
                </FormGroup></Col></Row>
                <Row><Col><FormGroup check className="form-checkinline">
                  <Label>
                    <Input checked={cellInfo.row.userInputHandling === 'static list' ? true : false} type="radio" name="userInputHandlingRadio" 
                      value="static list" onChange={this.userInputHandlingRadioChanged.bind(this, cellInfo)}
                    />
                    Static Suggestion List
                  </Label>
                </FormGroup></Col></Row>
                <Row><Col><FormGroup check className="form-checkinline">
                  <Label>
                    <Input checked={cellInfo.row.userInputHandling === 'no suggestions' ? true : false} type="radio" name="userInputHandlingRadio" 
                      value="no suggestions" onChange={this.userInputHandlingRadioChanged.bind(this, cellInfo)}
                    />
                    No Suggestions
                  </Label>
                </FormGroup></Col></Row>
              </Col>
              </Form>
            )
          else
            return null;
        }
      },
      {Header: 'Suggested Values',
        Cell: (cellInfo) => 
        {
          if ('true or false' !== cellInfo.row.keywordValueType && 'yes or no' !== cellInfo.row.keywordValueType && 
              'static list' === cellInfo.row.userInputHandling)
            return (<Button onClick={this.suggestedValues.bind(this, cellInfo.row)}>Suggested Values</Button>)
          else
            return null;
        }
      },
      {Header: 'Delete Keyword', filterable: false,
        Cell: (rowInfo) => 
        { 
          return (
            <div className="text-center">
              <Button onClick={this.confirmDeleteKeyword.bind(this, rowInfo.row)}>Delete</Button>
            </div>
          );
        }
      },
    ]
 
    let noDataText = (undefined === this.props.keywordGroup ? "Select a keyword from the group on the left..."  : "No keywords yet.  Create some!!!");

    return (
      <div>
        <AddKeywordToGroupModal  keywordGroup={this.props.keywordGroup} 
          closeModal={this.closeAddKeywordModal} modalIsOpen={this.state.addKeywordModalIsOpen}
          keywordValueTypes={this.props.keywordValueTypes} 
        />
        <SuggestedKValuesModal   
          keywordGroup={this.props.keywordGroup}
          keywordInfo={this.state.keywordInfo} refresh={this.fetchSuggestedKeywordValues} modalIsOpen={this.state.suggestedModalIsOpen}
          closeModal={this.closeSuggestedModal} suggestedKeywordValues={this.state.suggestedKeywordValues}
        />
        <ConfirmationModal modalIsOpen={this.state.confirmationModalIsOpen} closeModal={this.closeConfirmationModal} 
          modalText='Are you sure you want to delete this keyword? It will be removed from any object that has been tagged with this keyword.'/>
        <ButtonToolbar>
          <ButtonGroup>
            <Button onClick={this.newKeyword}>New</Button>
          </ButtonGroup>
        </ButtonToolbar>
        <ReactTable data={this.state.keywordGroupData} columns={columns} minRows={1} className="-striped -highlight" 
          noDataText={noDataText}
        />
      </div>
    );
  }

  suggestedValues(keywordInfo)
  {
    this.fetchSuggestedKeywordValues(keywordInfo.keywordId);

    this.setState(
    {
      suggestedModalIsOpen: true, 
      keywordInfo: keywordInfo,
    });
  }

  async updateKeywordInAGroup(cellInfo)
  {
    var bodyData = {};
    bodyData.keywordId = cellInfo.row.keywordId;
    bodyData.userInputHandling = cellInfo.row.userInputHandling;

    let result = await this.context.dbTwig.callRestAPI('dgBunker', 'updateKeyword', bodyData);
    if ('success' !== result.status) return this.context.dbTwig.apiErrorHandler(result, 'Error updating keyword in a group');
    this.getKeywords();
  }

  userInputHandlingRadioChanged(cellInfo, event)
  {
    cellInfo.row.userInputHandling = event.target.value;
    this.updateKeywordInAGroup(cellInfo);
  }
}

KeywordsInAGroup.contextType = AppContext;

export default KeywordsInAGroup